"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawBboxPoints = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../../utils");
var bbox_to_points_1 = require("../convert/bbox-to-points");
/**
 *
 * (example) north-west point
 *
 *                       pointWidthHalfPx
 *                          <-------->
 *                          :        :
 *                          :        :
 *                          :        :
 *                  ^ - - - +--------+--------+
 *                  |       |        .        |
 * pointWidthHalfPx |       |        .        |
 *                  |       |        .        |
 *                  v - - - + - - - -+------------
 *                          |        | +----------
 *                          |        | |      |
 *                          |        | |      |
 *                          +--------| |------+
 *                                   | |
 *
 *                                   : :
 *                                   : :
 *                                   : :
 *                                   <->
 *                              borderWidthPx
 */
var drawPoint = function (ctx, pointWidthPxHalf, pointWidthPx, x, y) {
    ctx.fillRect(x - pointWidthPxHalf, y - pointWidthPxHalf, pointWidthPx, pointWidthPx);
};
/*
 *     x0    x1    x2
 * y0 [ ]---[ ]---[ ]
 *     |           |
 * y1 [ ]         [ ]
 *     |           |
 * y2 [ ]---[ ]---[ ]
 */
var drawBboxPoints = function (ctx, bbox, pointWidthPx) {
    var e_1, _a;
    var pointWidthPxHalf = (0, utils_1.roundToInt)(pointWidthPx / 2);
    try {
        for (var _b = tslib_1.__values((0, bbox_to_points_1.bbox2Points)(bbox).values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var p = _c.value;
            drawPoint(ctx, pointWidthPxHalf, pointWidthPx, p.centerPos.x, p.centerPos.y);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
exports.drawBboxPoints = drawBboxPoints;
